import { Component, computed, effect, input, signal } from '@angular/core';
import { ComponentSize } from '@kaspacom/ui-kit';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'kc-wallet-avatar',
  standalone: true,
  templateUrl: './defi-wallet-avatar.component.html',
  styleUrl: './defi-wallet-avatar.component.scss',
})
export class KcWalletAvatarComponent {
  readonly address = input<string>('');
  readonly size = input<ComponentSize>('md');

  readonly failed = signal(false);

  constructor() {
    // A load failure (e.g. a request aborted mid-flight while the wallet
    // address was still churning through a network switch) otherwise sticks
    // forever — the avatar never retries even once a valid address settles.
    effect(() => {
      this.address();
      this.failed.set(false);
    });
  }

  readonly tokenId = computed(() => walletToTokenId(this.address()));
  readonly imgFilter = computed(() => walletToImgFilter(this.address()));
  readonly imgSrc = computed(
    () =>
      `${environment.krc721CacheStreamUrl}/optimized/${environment.yonatoshiTicker}/${this.tokenId()}`,
  );

  onImageError(): void {
    this.failed.set(true);
  }
}

function djb2(str: string): number {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) ^ str.charCodeAt(i);
    hash = hash | 0;
  }
  return Math.abs(hash);
}

function walletToTokenId(address: string): string {
  return ((djb2(address) % 10000) + 1).toString();
}

function walletToImgFilter(address: string): string {
  const h = djb2(address);
  const hue = h % 360;
  const saturate = 100 + ((h >>> 4) % 60);
  const contrast = 95 + ((h >>> 8) % 20);
  return `hue-rotate(${hue}deg) saturate(${saturate}%) contrast(${contrast}%)`;
}
